export default "__VITE_ASSET__BEhIjudR__"